import { BasePortalOutlet, CdkPortalOutlet, ComponentPortal, ComponentType, TemplatePortal } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  EmbeddedViewRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  Optional,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { matSnackBarAnimations } from '@angular/material/snack-bar';
import { TOAST_MESSAGE_DATA } from './toast-message.tokens';
import { ToastMessageData } from './toast-message-data.interface';
import { ToastMessageType } from './toast-message-type.enum';

@Component({
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [matSnackBarAnimations.snackBarState],
})
export class ToastMessageComponent extends BasePortalOutlet {
  @Input() public type!: ToastMessageType;
  @Input() public closeable = true;
  @Output() public destroy = new EventEmitter<void>();
  @ViewChild(CdkPortalOutlet, { static: true }) private readonly portalOutlet!: CdkPortalOutlet;

  public animationState = 'void';
  public iconComponent?: ComponentType<unknown>;
  public readonly toastMessageTypes = ToastMessageType;

  public constructor(
    @Optional() @Inject(TOAST_MESSAGE_DATA) private readonly data: ToastMessageData,
    public readonly viewContainerRef: ViewContainerRef
  ) {
    super();

    if (!data) {
      return;
    }

    this.type = data.config.type ?? ToastMessageType.Info;
    this.closeable = data.config.closeable ?? true;
  }

  @HostBinding('class') public get typeClass(): string {
    switch (this.type) {
      case ToastMessageType.Info:
        return 'info';
      case ToastMessageType.Success:
        return 'success';
      case ToastMessageType.Warning:
        return 'warning';
      case ToastMessageType.Error:
        return 'error';
    }
  }

  @HostBinding('@state') public get hostAnimation(): string {
    return this.animationState;
  }

  public enter(): void {
    this.animationState = 'visible';
  }

  public attachComponentPortal<C>(portal: ComponentPortal<C>): ComponentRef<C> {
    return this.portalOutlet.attachComponentPortal(portal);
  }

  public attachTemplatePortal<T>(portal: TemplatePortal<T>): EmbeddedViewRef<T> {
    return this.portalOutlet.attachTemplatePortal(portal);
  }

  public onCloseClick(): void {
    this.destroy.emit();

    if (this.data) {
      this.data.ref.close();
    }
  }
}
